import React, { useEffect, useState } from 'react';

interface CartAnimationProps {
  isVisible: boolean;
  onComplete: () => void;
}

const CartAnimation: React.FC<CartAnimationProps> = ({ isVisible, onComplete }) => {
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    if (isVisible) {
      setIsAnimating(true);
      const timer = setTimeout(() => {
        setIsAnimating(false);
        onComplete();
      }, 1000); // Animation duration

      return () => clearTimeout(timer);
    }
  }, [isVisible, onComplete]);

  if (!isVisible && !isAnimating) return null;

  return (
    <div className="fixed inset-0 pointer-events-none z-40">
      {/* Flying product animation */}
      <div
        className={`
          absolute top-1/2 left-1/2 w-8 h-8 bg-green-500 rounded-full
          flex items-center justify-center text-white font-bold
          transform transition-all duration-1000 ease-in-out
          ${isAnimating ? 'scale-100 opacity-100' : 'scale-0 opacity-0'}
        `}
        style={{
          animation: isAnimating ? 'flyToCart 1s ease-in-out forwards' : 'none'
        }}
      >
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
        </svg>
      </div>

      {/* Cart bounce animation target */}
      <div
        className={`
          absolute top-4 right-4 w-6 h-6 bg-red-500 rounded-full
          transform transition-all duration-300 ease-in-out
          ${isAnimating ? 'scale-150' : 'scale-100'}
        `}
        style={{
          animation: isAnimating ? 'cartBounce 0.5s ease-in-out 0.8s' : 'none'
        }}
      />

      <style>{`
        @keyframes flyToCart {
          0% {
            transform: translate(-50%, -50%) scale(1);
            opacity: 1;
          }
          50% {
            transform: translate(calc(50vw - 100px), calc(-50vh + 50px)) scale(0.8);
            opacity: 0.8;
          }
          100% {
            transform: translate(calc(50vw - 100px), calc(-50vh + 50px)) scale(0);
            opacity: 0;
          }
        }

        @keyframes cartBounce {
          0%, 100% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.5);
          }
        }
      `}</style>
    </div>
  );
};

export default CartAnimation;
